import React from 'react';

const SenderParcelInfo = ({handleChange, dim}) => {

    return (
        <div className='grid grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-6'>
            <label htmlFor='package-dim' className='text-md font-medium text-gray-700 sm:col-span-6'>
                Shipping Box Dimensions
            </label>

            <div className='sm:col-span-1'>
                <label htmlFor='width' className='block text-xs font-normal text-gray-600'>
                    Width (in)
                </label>
                <input
                    className='focus:ring-indigo-500 focus:border-indigo-500 block w-full  sm:text-sm border-gray-300 rounded-md max-w-xs'
                    onChange={handleChange('width')}
                    value={dim.width}
                    type='number'
                    name='width'
                    id='width'
                />
            </div>
            <div className='sm:col-span-1'>
                <label htmlFor='height' className='block text-xs font-normal text-gray-600'>
                    Height (in)
                </label>
                <input
                    className='focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md max-w-xs'
                    onChange={handleChange('height')}
                    value={dim.height}
                    type='number'
                    name='height'
                    id='height'
                />
            </div>

            <div className='sm:col-span-4'>
            </div>

            <div className='sm:col-span-1'>
                <label htmlFor='length' className='block text-xs font-normal text-gray-600'>
                    Length (in)
                </label>
                <input
                    className='focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md max-w-xs'
                    onChange={handleChange('length')}
                    value={dim.length}
                    type='number'
                    name='length'
                    id='length'
                />
            </div>
            <div className='sm:col-span-1'>
                <label htmlFor='weight' className='block text-xs font-normal text-gray-600'>
                    Weight (lb)
                </label>
                <input
                    className='focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md max-w-xs'
                    onChange={handleChange('weight')}
                    value={dim.weight}
                    type='number'
                    name='weight'
                    id='weight'
                />
            </div>

        </div>



    );
};

export default SenderParcelInfo;
